import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import PageHeader from "../../components/common/PageHeader";
import "./index.scss";
import UserPlaceholder from "../../components/common/UserPlaceholder";
import { useHistory, useLocation } from "react-router-dom";
import { capitalizeFirstLetter } from "../../utils/common";
import { tempAction } from "../../context/actions/tempAction";
const OperatorDetail = () => {
  const location = useLocation();
  const history = useHistory();

  const role = useSelector((state) => state?.user?.user?.role);
  const handleBack = () => {
    history.push("/users");
  };

  return (
    <>
      <div className="page-wrapper">
        <PageHeader className="with-btn">
          <div className="left-col d-inline-flex align-items-center">
            <Button
              color="link"
              className="backBtn"
              onClick={() => handleBack()}
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </Button>
            {location?.state?.optdata?.fname &&
              capitalizeFirstLetter(location?.state?.optdata?.fname) +
                " " +
                location?.state?.optdata?.lname}
          </div>
        </PageHeader>
        <div className="inner-wrapper">
          <div className="operator-detail">
            <div className="operator-blc">
              <div className="head">
                <div className="pic">
                  {location?.state?.optdata?.blob_name ? (
                    <img
                      className="img-fluid  rounded-circle"
                      src={location?.state?.optdata?.blob_name}
                      alt="Operator"
                    />
                  ) : (
                    <UserPlaceholder />
                  )}
                </div>
                <div className="lbl">{location?.state?.optdata?.name}</div>
              </div>
              <div className="inner">
                <div className="info-blc row-cell">
                  <div className="info-item d-flex">
                    <label>Phone Number</label>
                    <div className="desc">
                      <a href="tel:+ Phone Number">
                        {location?.state?.optdata?.phone}
                      </a>
                    </div>
                  </div>
                  <div className="info-item d-flex">
                    <label>Email</label>
                    <div className="desc mail">
                      <a href={`mailto:${location?.state?.optdata?.email}`}>
                        {location?.state?.optdata?.email}
                      </a>
                    </div>
                  </div>
                  <div className="info-item d-flex">
                    <label>Work Group</label>
                    <div className="desc">
                      {location?.state?.optdata?.location?.name}
                    </div>
                  </div>
                  <div className="info-item d-flex">
                    <label>Address</label>
                    <div className="desc">
                      {location?.state?.optdata?.location?.address}
                    </div>
                  </div>
                  <div className="info-item d-flex">
                    <label>Purchase Advice Upload Allowed</label>
                    <div className="desc">
                      {location?.state?.optdata?.purchase_advice ? "Yes" : "No"}
                    </div>
                  </div>
                  <div className="info-item d-flex">
                    <label>Role</label>
                    <div className="desc">
                      {location?.state?.optdata?.roles?.roleName}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OperatorDetail;
